module.exports = __webpack_public_path__ + "img/visitorsPage_btn.d9d849fc.png";